import { Icon } from 'components/Icon';
import { LANGUAGES, LanguageLocale } from 'utils/constants';

import { LanguageLinksItem } from './LanguageLinksItem';

type Props = {
  className?: string;
  url: Record<string, string>;
  showIcon?: boolean;
};

export function LanguageLinks({ className, url, showIcon = true }: Props) {
  return (
    <div className={className}>
      {showIcon && (
        <Icon initialColorName="todo-replace-me" name="line-globe" size={16} />
      )}

      {(Object.keys(LANGUAGES) as LanguageLocale[]).map((languageLocale) => (
        <LanguageLinksItem
          key={languageLocale}
          languageLocale={languageLocale}
          languageLocaleUrl={url[languageLocale]}
        />
      ))}
    </div>
  );
}
